import { render, staticRenderFns } from "./CookiePolicy.vue?vue&type=template&id=73c9337a&scoped=true&"
import script from "./CookiePolicy.vue?vue&type=script&lang=ts&"
export * from "./CookiePolicy.vue?vue&type=script&lang=ts&"
import style0 from "./CookiePolicy.vue?vue&type=style&index=0&id=73c9337a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c9337a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('73c9337a', component.options)
    } else {
      api.reload('73c9337a', component.options)
    }
    module.hot.accept("./CookiePolicy.vue?vue&type=template&id=73c9337a&scoped=true&", function () {
      api.rerender('73c9337a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/flatpages/CookiePolicy.vue"
export default component.exports